<template>
  <div class="home" :style="{ backgroundImage: `url(${data.bgInfo?.icon})` }">
    <div class="boli"></div>
    <headerComp :data="data.logoInfo" />
    <div class="homeBox">
      <div class="homeBoxTitle">{{data.bgInfo?.title}}</div>
      <div class="homeBoxText">{{ data.bgInfo?.desc }}</div>
      <div class="homeBoxBtn" @click="jumpPath()">
        <img src="https://p2.ssl.qhimg.com/t110b9a9301958510c83377c80a.png" alt="" />
        立即报名
      </div>
    </div>
  </div>
</template>

<script setup>
import headerComp from './headerTop.vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const jumpPath = () => {
  window.open(props.data.toUrl)
}

</script>

<style lang="scss" scoped>
.home {
  // background-image: url(https://p5.ssl.qhimg.com/t110b9a9301245986b620df4019.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  // aspect-ratio: 1440 / 632;
  height: 500px;
  position: relative;
  z-index: 10;
  .boli{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(2px);
  }
  &Box {
    width: 100%;
    height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 11;

    &Title {
      font-family: 360 守护体;
      font-size: 48px;
      font-weight: bold;
      line-height: 72px;
      letter-spacing: 7.5px;
      color: #ffffff;
      top: 120px;
    }
    &Text {
      color: rgb(255, 255, 255);
      font-family: Alibaba PuHuiTi 3.0;
      font-size: 24px;
      font-weight: 500;
      letter-spacing: 8px;
      top: 130px;
    }
    &Btn{
      position: absolute;
      cursor: pointer;
      width: 159.43px;
      height: 50px;
      border-radius: 8px;
      box-shadow: inset 0px 1px 0px 0px rgb(255, 255, 255);
      background: linear-gradient(0.00deg, rgb(145, 215, 255),rgb(225, 249, 255) 99.998%);
      // background-image: linear-gradient(45deg, rgb(225, 249, 255) 0%, rgb(201, 237, 246)  51%, rgb(225, 249, 255)  100%);
      display: flex;
      align-items: center;
      color: rgb(0, 64, 176);
      font-family: Alibaba PuHuiTi 3.0;
      font-size: 16px;
      font-weight: 500;
      justify-content: center;
      text-transform: uppercase;
      transition: 0.5s;
      background-size: 200% auto;
      border: 0px;
      // box-shadow: 0px 0px 14px -7px rgb(88, 142, 235);
      bottom: 136px;
      img{
        height: 30px;
        margin-right: 12px;
      }
      &:hover {
        background-position: right center;
        /* change the direction of the change here */
        color: rgb(0, 64, 176);
        text-decoration: none;
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }
}
</style>
